/**
 * Lightweight GA4 event helper (gtag already loaded in index.html)
 */
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    // ignore analytics failures
  }
}
